import { MarkdownContent } from '../ui/MarkdownContent';
import {
  looksLikeHtml,
  looksLikeMarkdown,
  sanitizeSupportHtml,
} from '../../utils/supportMessageContent';

type SupportMessageContentProps = {
  body: string;
  isHtml?: boolean;
  className?: string;
};

export function SupportMessageContent({
  body,
  isHtml = false,
  className = '',
}: SupportMessageContentProps) {
  const trimmed = body?.trim() ?? '';
  if (!trimmed) {
    return null;
  }

  const renderAsHtml = isHtml || looksLikeHtml(trimmed);
  if (renderAsHtml) {
    return (
      <div
        className={`support-message-html max-w-none overflow-x-auto text-sm text-secondary-800 [&_a]:text-primary-700 [&_a]:underline [&_img]:max-h-80 [&_img]:max-w-full [&_table]:w-full [&_td]:align-top [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 ${className}`.trim()}
        dangerouslySetInnerHTML={{ __html: sanitizeSupportHtml(trimmed) }}
      />
    );
  }

  if (looksLikeMarkdown(trimmed)) {
    return <MarkdownContent value={trimmed} className={className} emptyLabel="" />;
  }

  return (
    <div className={`whitespace-pre-wrap text-sm text-secondary-800 ${className}`.trim()}>
      {trimmed}
    </div>
  );
}
